import type { IllustrationProps } from '@bos/ui';
import { Illustration } from '@bos/ui';

export type AppIllustrationProps = IllustrationProps;

export const AppIllustration = (props: AppIllustrationProps) => (
	<Illustration {...props} />
);
